import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "rulesContainer",
    "ruleTemplate",
    "filtersContainer",
    "filterTemplate",
    "ruleItem",
  ];

  static values = {
    ruleIndex: { type: Number, default: 0 },
    filterWildcardSupportOperators: { type: Array, default: [] },
    filterOperatorPlaceholders: { type: Object, default: {} },
  };

  addRule(event) {
    event.preventDefault();

    const template = this.ruleTemplateTarget.content.cloneNode(true);
    const ruleElement = template.querySelector(".rule-item");

    // Replace NEW_RULE with the current rule index
    ruleElement.innerHTML = ruleElement.innerHTML.replace(/NEW_RULE/g, this.ruleIndexValue);
    ruleElement.dataset.ruleIndex = this.ruleIndexValue;

    // Update the rule number in the heading
    const heading = ruleElement.querySelector("h3");
    if (heading) {
      heading.textContent = `Rule ${this.ruleIndexValue + 1}`;
    }

    this.rulesContainerTarget.appendChild(ruleElement);
    this.ruleIndexValue++;
  }

  removeRule(event) {
    event.preventDefault();

    const ruleItem = event.target.closest(".rule-item");
    const destroyField = ruleItem.querySelector("input[name*='[_destroy]']");

    if (destroyField) {
      if (ruleItem.querySelector("input[name*='[id]']").value) {
        // Rule exists in database - mark for destruction
        destroyField.value = "1";
        ruleItem.style.display = "none";
      } else {
        // Rule not yet saved - remove from DOM
        ruleItem.remove();
      }
    }
  }

  addFilter(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const ruleIndex = button.dataset.ruleIndex;
    const ruleItem = button.closest(".rule-item");
    const filtersContainer = ruleItem.querySelector(
      `[data-admin--membership-plan-type-form-target="filtersContainer"][data-rule-index="${ruleIndex}"]`
    );
    const filterTemplate = ruleItem.querySelector(
      `[data-admin--membership-plan-type-form-target="filterTemplate"][data-rule-index="${ruleIndex}"]`
    );

    if (!filtersContainer || !filterTemplate) {
      console.error("Could not find filters container or template for rule", ruleIndex);
      return;
    }

    const currentFilters = filtersContainer.querySelectorAll(
      ".filter-item:not([style*='display: none'])"
    );
    const filterIndex = currentFilters.length;

    const template = filterTemplate.content.cloneNode(true);
    const filterElement = template.querySelector(".filter-item");

    // Replace placeholder with actual index
    filterElement.innerHTML = filterElement.innerHTML.replace(
      new RegExp(`NEW_FILTER_${ruleIndex}`, "g"),
      filterIndex
    );
    filterElement.dataset.filterIndex = filterIndex;

    filtersContainer.appendChild(filterElement);
  }

  removeFilter(event) {
    event.preventDefault();

    const filterItem = event.target.closest(".filter-item");
    const destroyField = filterItem.querySelector("input[name*='[_destroy]']");

    if (destroyField) {
      if (filterItem.querySelector("input[name*='[id]']").value) {
        // Filter exists in database - mark for destruction
        destroyField.value = "1";
        filterItem.style.display = "none";
      } else {
        // Filter not yet saved - remove from DOM
        filterItem.remove();
      }
    }
  }

  changeOperator(event) {
    const select = event.target;
    const operator = select.value;
    const filterItem = select.closest(".filter-item");

    if (!filterItem) return;

    const valueInput = filterItem.querySelector(".value-input");
    if (valueInput && this.filterOperatorPlaceholdersValue[operator]) {
      valueInput.placeholder = this.filterOperatorPlaceholdersValue[operator];
    }
  }
}
